import { Directive } from '@angular/core';

// Marks content projected after a ts-input's value (a unit such as "%") and gives it the shared adornment styling.
@Directive({
  selector: '[tsInputSuffix]',
  standalone: true,
  host: { class: 'self-center text-gray-400' },
})
export class TsInputSuffixDirective {}
